import React, { Component, useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import GooglePlacesAutocomplete from 'react-google-places-autocomplete'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faPlusCircle,
  faStar,
  faCheckCircle,
  faExclamationCircle,
  faTrash,
  faEye,
} from '@fortawesome/free-solid-svg-icons'
import { ToastContainer, toast } from 'react-toastify'
import Modal from 'react-modal'
import DatePicker from 'react-date-picker'

import Select from 'react-select'
import Button from 'react-bootstrap/Button'
import { loadStripe } from '@stripe/stripe-js'
import { addMongoUser, stopTimer } from '../../redux/actions'
import firebase from '../../services/firebase.js'
import PlaceHolderProfileImage from '../../assets/images/placeholder.png'
import metadata, * as Metadata from '../../metadata.js'

import GlobalStyles from '../styles/global.module.scss'
import Header from '../../components/Header'
import Constants from '../../values.js'
import Styles from './styles/Credentialing.module.scss'
import Config from '../../config'
import FileViewer from '../../components/pdf/FileViewer'

const axios = require('axios')
const windowHeight = window.innerHeight
const windowWidth = window.innerWidth
const customModalStyles = {
  overlay: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.44)',
  },
  content: {
    width: windowWidth / 2,
    height: windowHeight / 2,
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 100,
  },
}

const customDocModalStyles = {
  overlay: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.44)',
    zIndex: 10,
  },
  content: {
    zIndex: 10,
    width: '80vw',
    height: '90vh',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
}

const customModalStyles2 = {
  overlay: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.44)',
  },
  content: {
    width: windowWidth - 200,
    height: windowHeight - 20,
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 100,
  },
}

const Cme = (props) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const twilioToken = useSelector((state) => state.genericReducer?.twilioToken)
  const token = useSelector((state) => state.authReducer.token)

  const mongoUser = useSelector((state) => state.userReducer?.providerData)
  const userType = useSelector((state) => state.userReducer?.userType)
  const adminId = useSelector((state) => state.userReducer?.adminId)
  const firebaseAuthUser = useSelector(
    (state) => state.userReducer?.firebaseAuthUser,
  )

  const [loading, setLoading] = useState(false)
  const [openDoc, setOpenDoc] = useState(false)
  const [docFile, setDocFile] = useState('')
  const [docName, setDocName] = useState('')

  //WORK HISTORY DATA
  const [reference1, setReference1] = useState(null)
  const [reference2, setReference2] = useState(null)
  const [reference3, setReference3] = useState(null)
  const [workHistory, setWorkHistory] = useState([])
  const [currentCv, setCurrentCv] = useState('')

  const [cme, setCme] = useState([])
  const [uploadingIndex, setUploadingIndex] = useState(1)

  //IDENTIFICATION DATA
  const [npi, setNpi] = useState(null)
  const [caqh, setCaqh] = useState('')
  const [accessData, setAccessData] = useState(false)
  const [dea, setDea] = useState('')
  const [cds, setCds] = useState('')
  const [medicareId, setMedicareId] = useState('')
  const [medicaidId, setMedicaidId] = useState('')
  const [attest, setAttest] = useState(false)

  useEffect(() => {
    setLoading(true)
    getProviderData()
    setLoading(false)
  }, [])

  const getProviderData = () => {
    setLoading(true)
    // console.log('mongo user::', adminId, userType, mongoUser)
    // console.log('firebaseuser::', firebaseAuthUser)

    const url = `${Config.BACKEND_URL}providers`
    return axios({
      method: 'get',
      url,
      headers: { x_firebase_id: mongoUser.firebase_id, Authorization: `JWT ${token}` },
    })
      .then(({ data }) => {
        console.log('got doctor mongo details', data)
        setCme(
          data?.cme || [
            {
              applicable_state: null,
              organization: '',
              cme_topic: '',
              credits: '',
              date: new Date(),
              proof: '',
            },
          ],
        )

        setLoading(false)
        // dispatch(addMongoUser(data))
      })
      .catch((err) => {
        console.log('error when getting doctor mongo user CME', err)
      })
  }

  const onSavePressed = () => {
    let returnData = {
      cme: cme,
    }
    console.log(returnData)
    props.parentCallback(returnData)
  }

  const closeModal = () => {
    setOpenDoc(false)
    setDocFile('')
    setDocName('')
  }

  // On file select (from the pop up)
  const onFileChange = (event) => {
    // Update the state
    console.log(uploadingIndex)
    if (event?.target?.files[0]) {
      console.log(event?.target?.files[0])
      //   this.setState({
      //     modalFileName: event.target.files[0].name,
      //     modalFileType: event.target.files[0].type,
      //   })

      // if (event?.target?.files[0].type !== 'application/pdf') {
      //   toast.warning('Please upload PDF files')
      //   return
      // }

      setLoading(true)

      //SAVE IN FIRESTORE STORAGE
      const file = event?.target?.files[0]
      let storageUrl = `providers/${mongoUser.firebase_id}/${
        'CME' + uploadingIndex + '_' + file.name
      }`
      const storageRef = firebase.storage().ref()
      const uploadTask = storageRef.child(storageUrl).put(file)
      uploadTask.on(
        'state_changed',
        function (snapshot) {
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          console.log(`${progress}%`)
        },
        function (err) {
          // Handle unsuccessful uploads
          console.log('error when uploading image', err)
          setLoading(false)
          // self.saveUserToBackend(user)
        },
        function () {
          uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
            console.log(downloadURL)
            let temp = [...cme]
            temp[uploadingIndex].proof = downloadURL
            temp[uploadingIndex].proof_fileName = file.name
            setCme(temp)
            setLoading(false)
          })
        },
      )
    }
  }

  const renderLoader = () => (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: '100%',
        height: '60vh', // do not change this
      }}
    >
      <div className={GlobalStyles.loader} />
    </div>
  )

  const verifyNpiPressed = () => {
    if (!npi || npi.length !== 10) {
      // npi number must be exactly 10 digits
      toast.warning(
        'NPI number must be unique 10-digit National Provider Identifier assigned to the provider',
      )
      //   this.setState({
      //     error: true,
      //     modalErrorString:
      //       'NPI number must be unique 10-digit National Provider Identifier assigned to the provider',
      //   })
      return
    }

    // use the NPI registry API to verify the provided NPI
    // const { mongoUser, token } = this.props
    const url = `${Config.BACKEND_URL}provider/npi-verification`
    axios({
      method: 'post',
      headers: { Authorization: `JWT ${token}` },
      url,
      data: { number: npi, firebase_id: mongoUser.firebase_id },
    })
      .then(({ data }) => {
        console.log('got the response', data)
        if (data.npiVerification) {
          toast.success('Successfully verified NPI. You are all set.')
          //   this.props.addMongoUser(data.user)
          dispatch(addMongoUser(data.user))
          //   this.setState({
          //     modalLoading: false,
          //     modalError: false,
          //     modalIsOpen: false,
          //   })
        } else {
          toast.error('Invalid NPI number')
          //   this.setState({
          //     modalLoading: false,
          //     modalError: true,
          //     modalErrorString: 'Invalid NPI number. Could not verify.',
          //   })
        }
      })
      .catch((err) => {
        console.log('error when verifying NPI', err)
        toast.warning(
          'The verification system is down. Please try again later. If the problem persists, contact support.',
        )
        // this.setState({
        //   modalLoading: false,
        //   modalError: true,
        //   modalErrorString:
        //     'The verification system is down. Please try again later. If the problem persists, contact support. ',
        // })
      })
  }

  const renderCMES = () => {
    return (
      cme &&
      cme?.map((item, index) => {
        return (
          <div
            key={index.toString()}
            style={{
              width: '100%',
              marginBottom: '4%',
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            <div
              style={{
                width: '40%',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <p className={Styles.rowLabel} style={{ width: '100%' }}>
                Applicable State
              </p>
              <div style={{ width: '80%', marginLeft: 10 }}>
                <Select
                  placeholder="Select State..."
                  inputId="state"
                  options={metadata.stateResidence}
                  value={
                    item.applicable_state
                      ? {
                          label: item.applicable_state,
                          value: item.applicable_state,
                          abbreviation: item.abbr,
                        }
                      : null
                  }
                  isMulti={false}
                  isSearchable
                  autoBlur
                  onChange={(val) => {
                    let temp = [...cme]
                    temp[index].applicable_state = val.value
                    setCme(temp)
                  }}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      primary25: '#20A89233',
                      primary: '#20A892',
                    },
                  })}
                />
              </div>
            </div>

            <div
              style={{
                width: '40%',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <p className={Styles.rowLabel} style={{ width: '100%' }}>
                Organization/ Credit Type
              </p>
              <div style={{ width: '100%', marginLeft: 10 }}>
                <input
                  placeholder="Organization"
                  className={Styles.textInput}
                  style={{ width: '80%' }}
                  type="text"
                  value={item.organization}
                  onChange={(e) => {
                    let temp = [...cme]
                    temp[index].organization = e.target.value
                    setCme(temp)
                    //   const { licenseNumbers } = this.state
                    //   licenseNumbers[index] = e.target.value
                    //   this.setState({ licenseNumbers })
                  }}
                />
              </div>
            </div>

            <div
              style={{
                width: '40%',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <p className={Styles.rowLabel} style={{ width: '100%' }}>
                CME Topic
              </p>
              <div style={{ width: '100%', marginLeft: 10 }}>
                <input
                  placeholder="CME Topic"
                  className={Styles.textInput}
                  style={{ width: '80%' }}
                  type="text"
                  value={item.cme_topic}
                  onChange={(e) => {
                    let temp = [...cme]
                    temp[index].cme_topic = e.target.value
                    setCme(temp)
                    //   const { licenseNumbers } = this.state
                    //   licenseNumbers[index] = e.target.value
                    //   this.setState({ licenseNumbers })
                  }}
                />
              </div>
            </div>

            <div
              style={{
                width: '40%',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <p className={Styles.rowLabel} style={{ width: '100%' }}>
                Credits
              </p>
              <div style={{ width: '100%', marginLeft: 10 }}>
                <input
                  placeholder="Credits"
                  className={Styles.textInput}
                  style={{ width: '80%' }}
                  type="text"
                  value={item.credits}
                  onChange={(e) => {
                    let temp = [...cme]
                    temp[index].credits = e.target.value
                    setCme(temp)
                    //   const { licenseNumbers } = this.state
                    //   licenseNumbers[index] = e.target.value
                    //   this.setState({ licenseNumbers })
                  }}
                />
              </div>
            </div>

            <div
              style={{
                width: '40%',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <p className={Styles.rowLabel} style={{ width: '100%' }}>
                Date Completed
              </p>
              <div style={{ width: '100%', marginLeft: 10 }}>
                <DatePicker
                  // minDate={new Date('09/01/2019')}
                  // format={'MMM-dd-y'}
                  onChange={(date) => {
                    let temp = [...cme]
                    temp[index].date = date
                    setCme(temp)
                  }}
                  value={item.date || new Date()}
                  style={{ width: '40%', margin: '0% 0% 0% 5%' }}
                />
              </div>
            </div>

            {item?.proof && (
              <FontAwesomeIcon
                onClick={() => {
                  console.log(
                    item?.proof,
                    item?.proof_fileName?.split('.').pop(),
                  )
                  setDocFile(item?.proof)
                  setDocName(
                    item?.proof_fileName
                      ? item?.proof_fileName.split('.').pop()
                      : 'pdf',
                  )
                  setOpenDoc(true)
                }}
                icon={faEye}
                style={{
                  color: Constants.primaryTheme,
                  fontSize: 20,
                  width: '10%',
                  marginLeft: '1%',
                  cursor: 'pointer',
                }}
              />
            )}
            <label
              htmlFor={`proof${index}`}
              style={{
                textDecoration: 'underline',
                color: Constants.primaryTheme,
                cursor: 'pointer',
                margin: '0% 0% 0% 5%',
              }}
            >
              Upload Proof of CME Completion
            </label>
            <input
              id={`proof${index}`}
              // accept="application/pdf"
              style={{ display: 'none' }}
              type="file"
              onClick={() => {
                setUploadingIndex(index)
                console.log(cme)
              }}
              onChange={onFileChange}
            />
          </div>
        )
      })
    )
  }

  const renderContent = () => {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          padding: '1% 5%',
        }}
      >
        {/*State Requirements */}
        <div className={Styles.row}>
          <p className={Styles.rowLabel}>State Requirements </p>
          <p style={{ color: Constants.primaryThemeDark }}>
            <a
              href="https://www.cecentral.com/licensure/cme/"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: Constants.darkGray,
                textDecoration: 'underline',
              }}
            >
              View
            </a>
          </p>
        </div>

        {/*  CME */}
        <div
          style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            // alignItems: 'center',
            marginTop: '20px',
          }}
        >
          {/* <p className={Styles.rowLabel} style={{ alignSelf: 'flex-start' }}>
            
          </p> */}
          <div
            style={{
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            {renderCMES()}
          </div>
          <div
            onClick={() => {
              let temp = [...cme]
              temp.push({
                applicable_state: null,
                organization: '',
                cme_topic: '',
                credits: '',
                date: new Date(),
                proof: '',
              })
              setCme(temp)
            }}
            style={{
              cursor: 'pointer',
              marginLeft: 10,
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            <FontAwesomeIcon
              icon={faPlusCircle}
              style={{
                color: Constants.primaryTheme,
                fontSize: 20,
                marginRight: 5,
              }}
            />
            <p style={{ color: Constants.primaryTheme }}>Add another</p>
          </div>
        </div>

        <div
          style={{
            width: '100%',
            marginTop: 60,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
          }}
        >
          <Button
            onClick={onSavePressed}
            className={GlobalStyles.button}
            disabled={loading}
            style={{ width: 200 }}
            variant="primary"
          >
            {loading ? 'Loading....' : 'Save'}
          </Button>
          {/* {error && (
            <p style={{ marginTop: 4, fontSize: 12, color: 'red' }}>
              {errorString}
            </p>
          )} */}
        </div>

        <Modal
          ariaHideApp={false}
          isOpen={openDoc}
          onRequestClose={() => {
            setOpenDoc(false)
            setDocFile('')
            setDocName('')
          }}
          style={customDocModalStyles}
          contentLabel="Modal"
        >
          <FileViewer fileType={docName} fileName={docFile} />

          {/* <FileViewer
            fileType={
              docName && docName.length ? docName.split('.').pop() : 'pdf'
            }
            fileName={docFile}
          /> */}
          {/* <iframe
            style={{ height: '100%', width: '100%' }}
            src={`data:application/pdf;base64,${docFile}`}
          /> */}
        </Modal>

        {/* <Modal
          ariaHideApp={false}
          isOpen={openDoc}
          onRequestClose={() => {
            closeModal()
          }}
          style={customDocModalStyles}
          contentLabel="Modal"
        >
       

          {docName && docName.length !== 0 ? (
            <FileViewer
              fileType={docName.split('.').pop()}
              // fileType="pdf"

              fileName={docFile}
            />
          ) : (
            <FileViewer
              fileType={'pdf'}
              // fileType="pdf"
              fileName={docFile}
            />
          )}
      
        </Modal> */}
      </div>
    )
  }

  if (loading) return renderLoader()
  return renderContent()
}

export default Cme
